// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MouseButtons } from '../UtilsClasses/ControlsUtils';
import TradingButtonStripeTemplate from '@front/templates/TradingButtonStripeTemplate.html';
import { ContainerControl } from './ContainerControl';
import { Control } from './Control';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { NewContextMenuItemType } from '@shared/utils/ContextMenuUtils';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
export class TradingButtonStripe extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.TradingButtonStripe;
    }
    oninit() {
        super.oninit();
        this.on('tradingButtonClick', this.onTradingButtonClick);
        this.onMenuItemClicked = this.onMenuItemClicked.bind(this);
        this.observe('actionDataDict.*.visible', this.onVisibilityChanged);
    }
    oncomplete() {
        super.oncomplete();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        const key = 'panels.positions.ButtonsPanel.helpLabel';
        void this.set({
            hiddenItemsMessage: Resources.isHidden(key) ? '' : Resources.getResource(key),
            filteredText: ` (${Resources.getResource('property.Filtered')})`
        });
        const actionDataDict = this.get('actionDataDict');
        if (isNullOrUndefined(actionDataDict)) {
            return;
        }
        for (const action in actionDataDict) {
            const data = actionDataDict[action];
            data.text = Resources.getResource(data.locKey);
            data.tooltip = !isNullOrUndefined(data.tooltipLocKey) ? Resources.getResource(data.tooltipLocKey) : '';
        }
        void this.update('actionDataDict');
    }
    // TODO. Ugly.
    onMouseDown(event, isHeader) {
        if (Control.IsEventProcessed(event)) {
            return;
        }
        const origEvt = event.original;
        super.onMouseDown(event, isHeader);
        if (origEvt.button === MouseButtons.Right) {
            showContextMenu({ x: origEvt.clientX, y: origEvt.clientY, items: this.getMenuItems() });
        }
        Control.ProcessEvent(event);
    }
    // TODO. Optimize?
    getMenuItems() {
        const actionArr = this.get('actionArray');
        const actionDataDict = this.get('actionDataDict');
        const menuItemArr = [];
        for (let i = 0, len = !isNullOrUndefined(actionArr) ? actionArr.length : 0; i < len; i++) {
            const action = actionArr[i];
            const data = actionDataDict[action];
            menuItemArr.push({
                type: NewContextMenuItemType.Default,
                text: data.locKey,
                canCheck: true,
                checked: data.visible,
                value: action,
                event: (item) => {
                    this.onMenuItemClicked(item);
                }
            });
        }
        return menuItemArr;
    }
    onMenuItemClicked(menuItem) {
        const action = menuItem.value;
        void this.set('actionDataDict.' + action + '.visible', menuItem.checked);
    }
    // TODO. Optimize.
    onVisibilityChanged() {
        const actionArr = this.get('actionArray');
        const actionDataDict = this.get('actionDataDict');
        let visibleItemCount = 0;
        const len = !isNullOrUndefined(actionArr) ? actionArr.length : 0;
        for (let i = 0; i < len; i++) {
            const action = actionArr[i];
            const data = actionDataDict[action];
            const visible = data.visible;
            data.visibilityIdx = visible ? visibleItemCount++ : i;
        }
        void this.set('showHiddenItemsMessage', visibleItemCount === 0);
        void this.update('actionDataDict');
    }
    // TODO. Meh.
    setItemArray(itemArray) {
        const actionArr = [];
        const actionDataDict = {};
        for (let i = 0, len = !isNullOrUndefined(itemArray) ? itemArray.length : 0; i < len; i++) {
            const item = itemArray[i];
            const action = item.action;
            if (Resources.isHidden(item.locKey)) {
                continue;
            }
            actionArr.push(action);
            actionDataDict[action] = {
                action,
                enabled: item.enabled,
                visible: item.visible,
                visibilityIdx: i,
                instrument: item.instrument,
                locKey: item.locKey,
                text: Resources.getResource(item.locKey),
                isFiltered: item.isFiltered
            };
        }
        void this.set({
            actionArray: actionArr,
            actionDataDict
        });
    }
    // TODO. Ugly. Refactor.
    updateEnability(enabledActionSet) {
        if (isNullOrUndefined(enabledActionSet))
            return;
        const actionDataDict = this.get('actionDataDict');
        if (isNullOrUndefined(actionDataDict))
            return;
        for (const actionKey in actionDataDict) {
            if (isNullOrUndefined(enabledActionSet[actionKey])) {
                actionDataDict[actionKey].enabled = false;
                continue;
            }
            const actionData = actionDataDict[actionKey];
            actionData.enabled = enabledActionSet[actionKey].Allowed;
            actionData.tooltipLocKey = enabledActionSet[actionKey].ReasonLocalizationKey;
            actionData.tooltip = enabledActionSet[actionKey].ReasonText;
        }
        void this.update('actionDataDict');
    }
    updateButtonEnability(id, isEnabled, tooltip) {
        const actionDataDict = this.get('actionDataDict');
        if (isNullOrUndefined(actionDataDict)) {
            return;
        }
        const actionData = actionDataDict[id];
        if (isNullOrUndefined(actionData)) {
            return;
        }
        actionData.enabled = isEnabled;
        actionData.tooltip = tooltip;
        void this.update('actionDataDict');
    }
    setInstrument(action, instrument) {
        const actionDataDict = this.get('actionDataDict');
        if (isNullOrUndefined(actionDataDict))
            return;
        const actionData = actionDataDict[action];
        if (isNullOrUndefined(actionData))
            return;
        actionData.instrument = instrument;
        void this.update('actionDataDict');
    }
    // TODO. Refactor. Rename evants.
    onTradingButtonClick(context, action) {
        this.fire('tradingAction', action);
    }
    getBtnsVisibility() {
        const result = [];
        const actionDataDict = this.get('actionDataDict');
        if (isNullOrUndefined(actionDataDict)) {
            return result;
        }
        for (const actionKey in actionDataDict) {
            result.push({ a: actionKey, v: actionDataDict[actionKey].visible });
        }
        return result;
    }
    setBtnsVisibility(data) {
        if (isNullOrUndefined(data)) {
            return;
        }
        const actionDataDict = this.get('actionDataDict');
        if (isNullOrUndefined(actionDataDict)) {
            return;
        }
        for (let i = 0; i < data.length; i++) {
            const action = data[i].a;
            const visible = data[i].v;
            if (!isNullOrUndefined(actionDataDict[action])) {
                actionDataDict[action].visible = visible;
            }
        }
    }
}
ContainerControl.extendWith(TradingButtonStripe, {
    data: function () {
        return {
            showHiddenItemsMessage: false,
            hiddenItemsMessage: '',
            filteredText: '',
            actionArray: [],
            actionDataDict: {},
            buttonWidth: 100,
            buttonHeight: 22
        };
    },
    template: TradingButtonStripeTemplate
});
export class TradingButtonItem {
    constructor(action, locKey, isFiltered) {
        this.instrument = null;
        this.enabled = false;
        this.visible = true;
        this.action = action;
        this.locKey = locKey;
        this.isFiltered = isFiltered;
    }
}
